import { render, staticRenderFns } from "./AdditionalServicePriceLists.vue?vue&type=template&id=5c5c20fb&scoped=true&"
import script from "./AdditionalServicePriceLists.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicePriceLists.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServicePriceLists.vue?vue&type=style&index=0&id=5c5c20fb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c20fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VMenu,VRow,VSelect})
